import type { NDateLocale } from './enUS'
import { enIN } from 'date-fns/locale'

const datePaIN: NDateLocale = {
  name: 'pa-IN',
  locale: enIN
}

export default datePaIN
